import React from 'react'
import NavMain from './NavMain'
import ProjectDesc from './ProjectDesc'

export const ProjectsDisplay = () => {
  return (
    <div className='display'>
        <NavMain/>
        <ProjectDesc/>
     
        
    </div>
  )
}
